// Barchart component

import BarChartAdverse from "./charts/BarChartAdverse";

const ContaminationPlot = ({ period, data }) => {
  const datasets = {
    7: {
      unit: "day",
    },
    14: {
      unit: "day",
    },
    30: {
      unit: "day",
    },
    60: {
      unit: "week",
    },
    90: {
      unit: "week",
    },
    180: {
      unit: "week",
    },
  };

  const getUnit = () => {
    return datasets[period].unit;
  };

  const getData = () => {
    const contaminantData = data.find((item) => item._id === true)?.data || [];
    const noContaminantData =
      data.find((item) => item._id === false)?.data || [];

    return {
      datasets: [
        {
          label: "Detected",
          data: contaminantData,
          backgroundColor: "#1ca3f0",
          borderColor: "#a8e0ff",
        },
        {
          label: "Not Detected",
          data: noContaminantData,
          backgroundColor: "#3e517a",
          borderColor: "#a8e0ff",
        },
      ],
    };
  };

  return (
    <>
      {!data ? (
        <div className='d-flex justify-content-center align-items-center h-100 bg-light'>
          No data
        </div>
      ) : (
        <div className='d-flex justify-content-center align-items-center h-100'>
          <BarChartAdverse data={getData()} unit={getUnit()} period={period} />
        </div>
      )}
    </>
  );
};

export default ContaminationPlot;
